module.exports = __webpack_public_path__ + "864ce72aa8d984eec9667f5f3aae3e72.jpg";